export const GET_INTEGRATIONS = "GET-INTEGRATIONS";
export const GET_INTEGRATION_BY_ID = "GET-INTEGRATION-BY-ID";

export const SEARCH_PARAMS = {
  PAGE: "page",
  PAGE_SIZE: "page_size",
};
